<template>
    <div>
        <b-img :src="require('../../assets/8.jpg')" fluid alt="Responsive image" />
        <b-container>
            <h2 class="mt-4"><span v-if="$store.state.selectedTracks.length < 3">Good choice!</span><span v-if="$store.state.selectedTracks.length === 3">What a set!</span></h2>
            <h5 style="color: rgba(235, 63, 36,100);">You have chosen {{$store.state.selectedTracks.length}} of your 3 tracks.</h5>
            <h5>This is your playlist so far</h5>
            <p>Tap to remove a track.</p>
            <b-table v-on:row-clicked="deleteTrack" bordered responsive hover :items="tracksFromStore" thead-class="d-none"></b-table>
            <p v-if="$store.state.selectedTracks.length === 3">Ready? Get ready for step 2 of 3.</p>
            <b-row>
                <b-col></b-col>
                <b-col align-self="end">
                    <b-button v-if="$store.state.selectedTracks.length < 3" to="/tracks" variant="default">
                        Select another Choon!
                    </b-button>
                    <b-button v-if="$store.state.selectedTracks.length === 3" to="/persona-start" variant="default" block>
                        Next
                    </b-button>
                </b-col>
            </b-row>
        </b-container>
    </div>

</template>

<script>
    import { EventBus } from "../../EventBus";
    import _ from 'lodash';
    import { mapGetters } from 'vuex';

    export default {
        name: "MyTracksView",
        computed: {
          ...mapGetters({
              currentTracks: 'getSelectedTracks'
          })
        },
        data(){
          return {
              tracksFromStore: []
          }
        },
        methods: {
            deleteTrack(item) {
                this.$store.dispatch("removeFromSelectedTracks", item).then(() => {
                    EventBus.$emit('message', {message: 'Track removed', type: 'success'});
                });
            }
        },
        mounted() {
            _.forEach(this.currentTracks, (track) => {
                this.tracksFromStore.push(processTrackToOneLine(track));
            });
        },
        watch: {
            currentTracks(newVal) {
                this.tracksFromStore = [];
                _.forEach(newVal, (track) => {
                    this.tracksFromStore.push(processTrackToOneLine(track));
                });
            }
        }
    }
    function processTrackToOneLine(obj) {
        return {track: `${obj.artist} - ${obj.track}`};
    }
</script>

<style scoped>

</style>
